import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import toast from "react-hot-toast";
import { KTCard } from '../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../_metronic/helpers/components/KTCardBody';
import Content from '../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../_metronic/layout/core';
import { ToolbarWrapper } from '../../_metronic/layout/components/toolbar';
import { storeActivityIndicator } from '../../redux/reducers/authSlice';
import { RootState } from '../../redux/store';
import RefreshButton from '../../components/RefreshButton';
import { GorevYetkisiAlani, GorevYetkisiSatiri, GorevYetkisiService } from '../../services/GorevYetkisiService';

const QR_KOLONLARI: { alan: GorevYetkisiAlani, ad: string }[] = [
    { alan: 'depo', ad: 'Depo' },
    { alan: 'ofis', ad: 'Ofis' },
    { alan: 'arac', ad: 'Araç' },
];

// Görevlerim kartı ayrıca işaretlenmez: Araç yetkisi olan görevde (sürücü kaydı bağlı kullanıcıda) açılır (21.10.2026).
const KART_KOLONLARI: { alan: GorevYetkisiAlani, ad: string }[] = [
    { alan: 'mesaiPlanlama', ad: 'Mesai Planlama' },
    { alan: 'mesaiOnay', ad: 'Mesai Onay' },
];

const KOLONLAR = [...QR_KOLONLARI, ...KART_KOLONLARI];

const ORTALI: React.CSSProperties = { textAlign: 'center', width: 110 };

/**
 * Görev Yetkileri (İnsan Kaynakları > Tanımlamalar, QR Mesai Faz 2, 18.10.2026).
 * Görevler Sabit Tanımlar › Personel Görevi listesinden gelir. Her göreve okutabileceği QR türleri (Depo / Ofis / Araç)
 * ve mobil ana sayfada mesai başlayınca açılan Mesai Planlama kartı verilir; Görevlerim kartı Araç yetkisinden gelir. Değişiklikler Kaydet ile gider.
 */
const GorevYetkisi = () => {
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "İnsan Kaynakları > Tanımlamalar > Görev Yetkileri"
    const menu = auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName);
    const kaydedebilir = !!(menu?.canUpdate || menu?.canInsert);

    const [satirlar, setSatirlar] = useState<GorevYetkisiSatiri[]>([]);
    const [ilk, setIlk] = useState<string>('[]');

    useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        try {
            dispatch(storeActivityIndicator(true));

            var response = await GorevYetkisiService.liste();

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                return;
            }

            var liste = (response.data ?? []).slice().sort((a, b) => (a.gorevAdi ?? '').localeCompare(b.gorevAdi ?? '', 'tr'));
            setSatirlar(liste);
            setIlk(JSON.stringify(liste));
        } catch (error: any) {
            toast.error(error);
        } finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const degisti = JSON.stringify(satirlar) != ilk;

    const isaretle = (gorevId: string, alan: GorevYetkisiAlani) => {
        setSatirlar(satirlar.map(x => x.gorevId == gorevId ? { ...x, [alan]: !x[alan] } : x));
    }

    /** Başlıktaki kutu: kolonun tamamını açar ya da kapatır. */
    const kolonuIsaretle = (alan: GorevYetkisiAlani) => {
        var hepsi = satirlar.length > 0 && satirlar.every(x => x[alan]);
        setSatirlar(satirlar.map(x => ({ ...x, [alan]: !hepsi })));
    }

    const kaydet = async () => {
        try {
            dispatch(storeActivityIndicator(true));

            var response = await GorevYetkisiService.kaydet({
                satirlar: satirlar.map(x => ({
                    gorevId: x.gorevId,
                    depo: x.depo,
                    ofis: x.ofis,
                    arac: x.arac,
                    gorevlerim: x.arac,
                    mesaiPlanlama: x.mesaiPlanlama,
                    mesaiOnay: x.mesaiOnay
                }))
            });

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                return;
            }

            toast.success('Görev yetkileri kaydedildi. Yeni yetki bir sonraki okutmada geçerli olur.');
            setIlk(JSON.stringify(satirlar));
        } catch (error: any) {
            toast.error(error);
        } finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const yetkisiz = satirlar.filter(x => !x.depo && !x.ofis && !x.arac && x.personelSayisi > 0);

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <div style={{ flex: 1 }}></div>
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='ebbe-card mb-3'>
                    <KTCardBody>
                        <h4 className="mb-2 text-black">Görev Yetkileri</h4>
                        <div className="text-muted fs-7 mb-5">
                            Görevler Sabit Tanımlar › Personel Görevi listesinden gelir. Her göreve okutabileceği QR türleri ve mobil ana sayfada mesai başlayınca açılan kartlar verilir; birden çok seçilebilir.
                            {' '}Depo yetkisi Lojistik ve Ambalaj QR'larının ikisini de kapsar.
                        </div>

                        <div className='table-responsive'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th rowSpan={2} style={{ verticalAlign: 'bottom' }}>Görev</th>
                                        <th colSpan={QR_KOLONLARI.length} style={{ textAlign: 'center' }}>Okutabileceği QR</th>
                                        <th colSpan={KART_KOLONLARI.length} style={{ textAlign: 'center' }}>Mobil kartlar</th>
                                        <th rowSpan={2} className='custom-text-right' style={{ verticalAlign: 'bottom' }}>Personel</th>
                                    </tr>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        {
                                            KOLONLAR.map(k =>
                                                <th key={k.alan} style={ORTALI}>
                                                    <div className='d-flex flex-column align-items-center gap-1'>
                                                        <span>{k.ad}</span>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid' title={k.ad + ': tümünü seç / kaldır'}>
                                                            <input
                                                                className='form-check-input'
                                                                type='checkbox'
                                                                disabled={!kaydedebilir || satirlar.length == 0}
                                                                checked={satirlar.length > 0 && satirlar.every(x => x[k.alan])}
                                                                onChange={() => kolonuIsaretle(k.alan)}
                                                            />
                                                        </label>
                                                    </div>
                                                </th>
                                            )
                                        }
                                    </tr>
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        satirlar.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı. Görevler Sabit Tanımlar › Personel Görevi'nden eklenir.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        satirlar.map(s =>
                                            <tr key={s.gorevId}>
                                                <td className='text-gray-800'>{s.gorevAdi}</td>
                                                {
                                                    KOLONLAR.map(k =>
                                                        <td key={k.alan} style={ORTALI}>
                                                            <div className='d-flex justify-content-center'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                    <input
                                                                        className='form-check-input'
                                                                        type='checkbox'
                                                                        aria-label={s.gorevAdi + ' ' + k.ad}
                                                                        disabled={!kaydedebilir}
                                                                        checked={s[k.alan]}
                                                                        onChange={() => isaretle(s.gorevId, k.alan)}
                                                                    />
                                                                </label>
                                                            </div>
                                                        </td>
                                                    )
                                                }
                                                <td className='custom-text-right'>{s.personelSayisi}</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>

                        {
                            yetkisiz.length > 0 && (
                                <div className='alert alert-warning d-flex align-items-start p-4 mt-3 mb-0'>
                                    <i className='fa fa-exclamation-triangle text-warning fs-3 me-3 mt-1'></i>
                                    <div className='fs-7'>
                                        Hiç QR yetkisi olmayan görevde personel var: <b>{yetkisiz.map(x => x.gorevAdi).join(', ')}</b>. Bu görevdeki personel QR okutamaz.
                                    </div>
                                </div>
                            )
                        }

                        <div className="text-muted fs-7 mt-3">
                            Araç yetkisi olan görevde personel araç QR'ı okutunca personel mesaisi açılır (puantaja girer, siparişe gitmez; konum alınır, çap kontrolü yapılmaz).
                            {' '}<b>Görevlerim</b> kartı Araç yetkisi olan görevde, kullanıcıya sürücü kaydı da bağlıysa açılır (seferler sürücü kaydından gelir).
                            {' '}Mobil kartlar yalnız mesai açıkken görünür. Personeli olmayan, yalnız sürücüye bağlı kullanıcı araç QR'ını eskisi gibi okutur ve Görevlerim'i görür.
                        </div>
                    </KTCardBody>
                </KTCard>

                <KTCard className="ebbe-card mt-3">
                    <KTCardBody>
                        <div className="d-flex flex-row justify-content-between align-items-center">
                            <div className={"fs-7 " + (degisti ? 'text-warning' : 'text-muted')}>
                                {degisti ? 'Kaydedilmemiş değişiklik var.' : ''}
                            </div>
                            <div>
                                {
                                    kaydedebilir && (
                                        <button className="btn btn-primary btn-sm" disabled={!degisti} onClick={kaydet}>Kaydet</button>
                                    )
                                }
                            </div>
                        </div>
                    </KTCardBody>
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default GorevYetkisi;
